<template>
  <div>
    <div
      v-if="objectImageExist(mainimageData)"
      class="main-image-container"
      :style="getImageStyle(mainimageData)"
    ></div>
    <div
      class="tr-test game-tr-test-multi game-tr-test-multi-dimentions"
      :class="[{ 'game-tr-test-multi-dimentions-fullscreen': isFullScreenBackground }]"
    >
      <div v-if="objectImageExist(imageData)" class="main-image-container" :style="getImageStyle(imageData)"></div>
      <div
        class="overflow-element"
        :class="[{ 'overflow-with-image': objectImageExist(imageData) }]"
        :style="getStyle(imageData)"
      >
        <div
          class="element-container"
          :class="[
            { 'question-container-image': isImageInQuestion(element) },
            { 'element-container-vertical': element.vertical },
            { block: inputStatus(elementIndex) === 'correct' },
          ]"
          :style="'height:' + setHeight(element.questionElementHeight, manualElementHeight) + 'px;'"
          v-for="(element, elementIndex) in questionsList"
          :key="'element_' + elementIndex"
          :id="'element_' + elementIndex"
        >
          <div
            class="question-container inner-element-container"
            v-if="isQuestion(element.question)"
            :style="{ height: setHeight(element.questionHeight, questionHeight) + 'px' }"
          >
            <div class="question-text" v-if="!element.question.imageData">
              <mb-audio
                v-if="element.audioSrc"
                :item-audio="{ audioSrc: element.audioSrc, position: 'relative', audioCss: element.audioCss }"
              >
              </mb-audio>
              <span v-if="!checkKatexMarker(element.question)" v-html="element.question"></span>
              <span v-if="checkKatexMarker(element.question)">
                <ps-text
                  :font-size="`${isKatexFontSize}`"
                  :text-value="`${element.question}`"
                  v-if="isKatexFontSize"
                ></ps-text>
                <ps-text :text-value="`${element.question}`" v-else></ps-text>
              </span>
            </div>
            <div class="image-container" v-if="element.question.imageData">
              <div class="question-text" v-if="element.question.text">
                <mb-audio
                  v-if="element.audioSrc"
                  :item-audio="{ audioSrc: element.audioSrc, position: 'relative', audioCss: element.audioCss }"
                >
                </mb-audio>
                <span v-if="!checkKatexMarker(element.question.text)" v-html="element.question.text"></span>
                <span v-if="checkKatexMarker(element.question.text)">
                  <ps-text :text-value="`${element.question.text}`"></ps-text>
                </span>
              </div>
              <img
                style="margin-top: 10px"
                :src="getImage(element.question.imageData)"
                :style="{
                  width: element.question.imageData.width + 'px',
                  height: element.question.imageData.height + 'px',
                }"
              />
            </div>
          </div>
          <div
            class="answer-container inner-element-container"
            :class="[{ 'no-questoin-class': !isQuestion(element.question) }]"
            :style="{ height: setHeight(element.answerHeight, answerHeight) + 'px' }"
          >
            <div
              class="answer-item"
              @click="resetCheckStatus"
              v-for="(answer, answerIndex) in element.answers"
              :key="'answer_' + answerIndex"
            >
              <div class="">
                <mb-audio
                  v-if="answer.audioSrc"
                  :item-audio="{ audioSrc: answer.audioSrc, position: 'relative', audioCss: answer.audioCss }"
                >
                </mb-audio>
                <label class="label-container">
                  <!-- <div class="text-container" v-if="isText(answer)" v-katex="answer.text"></div> -->
                  <div v-if="isText(answer)">
                    <div class="text-container" v-if="!checkKatexMarker(answer.text)" v-html="answer.text"></div>

                    <div class="text-container" v-if="checkKatexMarker(answer.text)">
                      <ps-text :font-size="`${isKatexFontSize}`" :text-value="`${answer.text}`"></ps-text>
                    </div>
                  </div>

                  <div
                    class="image-container"
                    :style="{ ...{ 'background-image': 'url(' + getImage(answer) + ')' }, ...answer.cssStyle }"
                    v-else
                  ></div>
                  <input
                    type="radio"
                    :name="'element_' + elementIndex"
                    :value="answer.value"
                    v-model="selected['element_' + elementIndex]"
                  />
                  <span
                    class="checkmark"
                    :class="[
                      { correct: inputStatus(elementIndex) === 'correct' },
                      { incorrect: inputStatus(elementIndex) === 'incorrect' },
                    ]"
                  >
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @namespace TestMulti
 */

import _ from 'lodash';
import * as utils from '../../Utils/inputUtils';
import defaultMixin from '../../mixins/defaultMixin';
import MbAudio from '__mainSrcDir/components/MbAudio/MbAudio';
import PsText from '../TrInput/PsText';
export default {
  name: 'tr-test-multi',
  components: { MbAudio, PsText },
  mixins: [defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      katexFontSize: this.startGameConfig.katexFontSize,
      fullScreen: this.startGameConfig.fullScreen,
      baseQuestionsList: _.cloneDeep(this.startGameConfig.items),
      manualElementHeight: this.startGameConfig.questionElementHeight,
      questionHeight: this.startGameConfig.questionHeight,
      answerHeight: this.startGameConfig.answerHeight,
      questonShuffle: this.startGameConfig.shuffle,
      mainimageData: {},
      imageData: {},
      selected: {},
    };
  },
  created() {},
  beforeMount() {
    this.init();
  },
  mounted() {},
  methods: {
    checkKatexMarker(item) {
      let flag = item.search('_#');
      if (flag == -1) {
        return false;
      }
      return true;
    },
    setHeight(inElement, outOfElement) {
      if (inElement) {
        return inElement;
      } else if (outOfElement) {
        return outOfElement;
      }
    },
    init() {
      this.questionsList = this.processQuestionsList();
      _.each(_.cloneDeep(this.questionsList), (question, questionIndex) => {
        this.selected = Object.assign({}, this.selected, {
          ['element_' + questionIndex]: '',
        });
        _.each(question.answers, (answer, answerIndex) => {
          this.questionsList[questionIndex].answers[answerIndex] = Object.assign(
            {},
            this.questionsList[questionIndex].answers[answerIndex],
            {
              value: this.questionsList[questionIndex].answers[answerIndex].correct
                ? 'CORRECT'
                : 'question' + questionIndex + 'answer' + answerIndex,
              checked: false,
            }
          );
        });
      });
    },
    /**
     * test if object image objectExist
     * @member TestMulti
     * @method objectExist
     * @param  {Object}    item testiing element
     * @return {Boolean}         true if is object
     */
    objectImageExist(item) {
      return _.isObject(item) && !_.isNil(item.imagePath);
    },
    getImage(item) {
      console.log(item);
      return require(`__staticDir/${this.$store.getters.multibookType}/${item.imagePath}`);
    },
    getImageStyle(imageData) {
      if (_.isObject(imageData) && imageData.imagePath) {
        if (!imageData.pos) {
          imageData = Object.assign({}, imageData, {
            pos: {
              x: 0,
              y: 0,
            },
          });
        }
        if (!imageData.height) {
          imageData = Object.assign({}, imageData, {
            height: 358,
          });
        }
        if (!imageData.width) {
          imageData = Object.assign({}, imageData, {
            width: 1850,
          });
        }
      }
      return _.merge(this.getCustomStyle(imageData), {
        // 'position': 'absolute',
        'background-image': `url(${require(`__staticDir/${this.$store.getters.multibookType}/${imageData.imagePath}`)})`,
        top: utils.elementTopPosition(imageData.pos.y, imageData.offsetVertical),
        left: utils.elementLeftPosition(imageData.pos.x, imageData.offsetHorizontal),
        width: utils.elementWidth(imageData.width),
        height: utils.elementHeight(imageData.height),
      });
    },
    getStyle(item) {
      let height;
      /** @type {Number} margin-bottom:10px; in main-image-container */
      let imageMarginBottom = 10;
      if (item.height) {
        /** 795 is height available scen */
        height = 795 - item.height - imageMarginBottom;
        if (!_.isNumber(height) || height < 0) {
          height = undefined;
        }
      }
      return _.merge({ height: [height, 'px'].join('') }, this.getCustomStyle(item));
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
    inputStatus(index) {
      let element = 'element_' + index;
      let status = 'unset';
      if (this.$store.getters.gameCheckSwitch && this.selected[element] === 'CORRECT') {
        status = 'correct';
      } else if (this.$store.getters.gameCheckSwitch) {
        status = 'incorrect';
      }
      if (
        document.querySelector(['#element_', index].join('')) &&
        document.querySelector(['#element_', index].join('')).classList.contains('block')
      ) {
        status = 'correct';
      }
      return status;
    },
    resetCheckStatus() {
      this.$store.dispatch('resetCheckStatus');
      /** return true becouse want to event to propagate  */
      return true;
    },
    isText(obj) {
      return _.has(obj, 'text');
    },
    isQuestion(obj) {
      return !_.isEmpty(obj);
    },
    isImageInQuestion(obj) {
      return _.some(obj.answers, 'imagePath');
    },
    selectRadioButto(qIndex, aIndex) {
      let element = this.$refs['question' + qIndex + 'answer' + aIndex];
      this.selected['element_' + qIndex + '_' + aIndex] = element[0].value;
    },
    /**
     * reset all containerEnd without reset reactivity
     * @member TestMulti
     * @method resetGameAction
     */
    resetGameAction() {
      _.each(this.selected, (item, key, collection) => {
        collection[key] = '';
        document.querySelector(['#', key].join('')) &&
          document.querySelector(['#', key].join('')).classList.remove('block');
      });
      this.init();
    },
    checkGameAction() {
      let status = _.reduce(
        this.selected,
        (result, value, key) => {
          let temVal = null;
          if (value === 'CORRECT') {
            temVal = result && true;
          } else {
            temVal = false;
            // this.selected[ key ] = "";
            // setTimeout( () => {
            //   this.selected[ key ] = "";
            // }, 2000 );
          }
          return temVal;
        },
        true
      );
      console.log('ANSWER: ', status);
      if (!status) {
        _.each(this.selected, (item, key) => {
          console.log('item', item);
        });
      }
      return status;
    },
    processQuestionsList() {
      let newQuestionList = [];
      let selectedItem;
      if (this.startGameConfig.pick && this.startGameConfig.items) {
        selectedItem = this.startGameConfig.shuffle
          ? _.sampleSize(_.cloneDeep(this.startGameConfig.items))
          : _.take(_.cloneDeep(this.startGameConfig.items));
        /** @type wybieramy tylko jeden zestaw pytań na raz  */
        selectedItem = selectedItem[0];
      } else {
        selectedItem = this.startGameConfig;
      }
      // let selectedItem = _.sample( _.cloneDeep(this.startGameConfig.items) );
      if (selectedItem.imageData) {
        this.imageData = selectedItem.imageData;
      }
      if (this.startGameConfig.mainImage) {
        this.mainimageData = _.cloneDeep(this.startGameConfig.mainImage);
      }
      /**  get item if pick and shuffle */
      if (selectedItem.shuffle && selectedItem.pick) {
        selectedItem.questionsList = _.sampleSize(_.cloneDeep(selectedItem.questionsList), selectedItem.pick);
      } else if (
        /**  get item if pick and not shuffle */
        !_.isBoolean(selectedItem.shuffle) &&
        !selectedItem.shuffle &&
        selectedItem.pick
      ) {
        selectedItem.questionsList = _.take(_.cloneDeep(selectedItem.questionsList), selectedItem.pick);
      }
      _.each(_.cloneDeep(selectedItem.questionsList), (item, index) => {
        if (item.items && item.pick) {
          item = _.sampleSize(_.cloneDeep(item.items), item.pick)[0];
        }
        let audioSrc = item.audioSrc;
        let audioCss = item.audioCss;
        let question = item.question;
        let answers = item.answers;
        let vertical = item.vertical;
        let questionHeight = item.questionHeight;
        let answerHeight = item.answerHeight;
        let questionElementHeight = item.questionElementHeight;
        if (item.pick) {
          // this.questionsList[index].answers = _.sampleSize(item.answers,item.pick);
          answers = _.sampleSize(_.cloneDeep(item.answers), item.pick);
        }
        if (item.shuffle) {
          answers = _.shuffle(item.answers);
        }
        newQuestionList.push({
          audioSrc,
          audioCss,
          question,
          answers,
          vertical,
          questionElementHeight,
          questionHeight,
          answerHeight,
        });
      });
      this.questionsList = this.questonShuffle ? _.shuffle(newQuestionList) : newQuestionList;
      return this.questionsList;
    },
  },
  computed: {
    isFullScreenBackground() {
      if (this.fullScreen) {
        return true;
      } else {
        return false;
      }
    },
    isKatexFontSize() {
      if (this.katexFontSize) {
        return this.katexFontSize;
      } else {
        return null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// @import '~pretty-checkbox/src/pretty-checkbox.scss';
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';
// @import '~@/assets/sass/testBase';
// @import '~@/assets/sass/testMulti';
$elementWidth: 1853px;
$elementHeight: 153px;
.label-container {
  @media (min-width: 1200px) {
    max-width: 97%;
    width: 1780px;
  }
}
.game-tr-test-multi-dimentions {
  height: 795px;
  width: 1906px;
  top: 160px;
  left: 11px;
}
.game-tr-test-multi-dimentions-fullscreen {
  height: 1080px;
  width: 1920px;
  top: 0px;
  left: 0px;
  padding-top: 160px;
}
.game-tr-test-multi {
  position: relative;

  display: block;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  // height: 865px;

  // padding: 160px 56px 127px 11px;
  box-sizing: border-box;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
  // overflow-y: scroll;
  font-size: 28px;
  // height: 100%;
  .block {
    pointer-events: none;
  }
  // .overflow-with-image {
  //     height: 35% !important;
  // }
  .overflow-element {
    height: 100%;
    overflow: auto;
    overflow-x: hidden;
    .element-container {
      position: relative;
      display: block;
      width: $elementWidth;
      height: $elementHeight;
      border-radius: 20px;
      border: 3px solid $backgroundControlPanelColor;
      margin-bottom: 20px;
      .inner-element-container {
        display: block;
        // position: absolute;
        width: 100%;
        height: 30%;
      }
      .question-container {
        height: 40%;
        // background-color: rgba(227, 230, 123, 0.29);
        .question-text {
          line-height: 28px;
          text-align: left;
          padding-top: 28px;
          padding-left: 35px;
          padding-right: 35px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }
      }
      .answer-container {
        height: 60%;
        // background-color: rgba(6, 45, 172, 0.36);
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        .answer-item {
          display: flex;
          min-width: 22%;
          justify-content: flex-start;
          align-items: center;
          height: 49px;

          /* The label-container */
          .label-container {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            position: relative;
            height: 49px;
            padding-left: 70px;
            margin-bottom: 12px;
            cursor: pointer;
            // font-size: 22px;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            .text-container {
              text-align: left;
            }
            .image-container {
              // width: 250px;
              // height: 250px;
              width: 200px;
              height: 180px;
              background-position: center;
              background-repeat: no-repeat;
              background-size: contain;
            }
          }

          /* Hide the browser's default radio button */
          .label-container input {
            position: absolute;
            opacity: 0;
            cursor: pointer;
          }

          /* Create a custom radio button */
          .checkmark {
            position: absolute;
            top: 0;
            left: 8px;
            height: 49px;
            width: 49px;
            background-image: url('~@/assets/icons/both/game/testIcons/default.png');
            background-position: center;
            background-repeat: no-repeat;
            background-size: contain;
            border-radius: 50%;
          }

          /* On mouse-over, add a grey background color */
          // .label-container:hover input ~ .checkmark {
          //     // background-color: #ccc;
          //     background-image: url("~@/assets/icons/both/game/testIcons/set.png");
          // }

          /* When the radio button is checked, add a blue background */
          .label-container input:checked ~ .checkmark {
            background-image: url('~@/assets/icons/both/game/testIcons/set.png');
          }
          // correct style
          .label-container input:checked ~ .checkmark.correct {
            background-image: url('~@/assets/icons/both/game/testIcons/correct.png');
          }
          // incorrect style
          .label-container input:checked ~ .checkmark.incorrect {
            background-image: url('~@/assets/icons/both/game/testIcons/incorrect.png');
          }

          /* Create the indicator (the dot/circle - hidden when not checked) */
          .checkmark:after {
            content: '';
            position: absolute;
            display: none;
          }

          /* Show the indicator (dot/circle) when checked */
          .label-container input:checked ~ .checkmark:after {
            display: block;
          }

          /* Style the indicator (dot/circle) */
          .label-container .checkmark:after {
            // top: 9px;
            // left: 9px;
            // width: 8px;
            // height: 8px;
            // border-radius: 50%;
            // background: white;
            visibility: hidden;
          }
        }
      }
      .no-questoin-class {
        height: 100%;
      }
    }
    .element-container-vertical {
      height: 300px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: flex-start;

      .answer-container {
        height: 100%;
        padding-left: 60px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: flex-start;
      }
    }
    .question-container-image {
      height: 300px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: flex-start;
    }
  }
  .main-image-container {
    position: relative;
    display: block;
    width: $elementWidth;
    height: $elementHeight;
    margin-bottom: 10px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  }
}
</style>
